export default "__VITE_ASSET__BdqDiooj__"